import React from 'react';
import { getIn, ErrorMessage } from "formik";
import TextError from '../error-message';

export default function InputText(props) {
  const {secondLabel, ...inputField} = props;
  const { field, form, type, placeholder, disabled, decimal, hideerrormsg, setFieldValue } = inputField;

  const name = field.name;

  function getStyles(errors, touched, name) {
    if (getIn(errors, name) && getIn(touched, name)) {
      return {
        border: '1px solid #FF5151',
        background: '#fcd9d4'
      }
    }
  }

  function limitDecimalPlaces(e, count) {
    if (e.target.value.indexOf('.') == -1) { return; }
    if ((e.target.value.length - e.target.value.indexOf('.')) > count) {
      e.target.value = parseFloat(e.target.value).toFixed(count);
    }
  }

  return <React.Fragment>
    <div className="aisC">
      {!hideerrormsg && <ErrorMessage name={name} render={TextError}/>}
      <input
        {...inputField}
        id={name}
        value={field.value}
        style={getStyles(form.errors, form.touched, name)}
        type={type}
        placeholder={placeholder || ''}
        disabled={disabled}
        onPaste={(e) => {
          const data = e.clipboardData.getData('Text')
          if (data.includes('e') || data.includes('-')) {
            e.preventDefault();
          }
        }}
        onKeyPress={(e) => {
          if (e.ctrlKey || e.altKey || (47 < e.charCode && e.charCode < 58 && e.shiftKey === false) ||
              (95 < e.charCode && e.charCode < 101) || (101 < e.charCode && e.charCode < 106) ||
              (e.charCode === 8) || (e.charCode === 9) || (e.charCode > 34 && e.charCode < 40) || (e.charCode === 46)) {
            return
          } else {
            e.preventDefault();
          }
        }}
        onInput={(e) => {
          if (e.nativeEvent.data == '.' && e.target.value == '') {
            e.target.value = ''
          }
          limitDecimalPlaces(e, 2)
        }}
        onChange={(e) => {
          setFieldValue(
            name,
            e.target.value.replace(/,/g, "")
          );
        }}
      />
      <span className="formUnit">{secondLabel}</span>
    </div>
  </React.Fragment>
}
